/**
 * @fileoverview DataContext component
 *
 * @example
 * // Usage:
 * import { DataContext } from './DataContext'
 *
 * function Component() {
 *   // ...
 * }
 */

import { createContext, Dispatch, SetStateAction } from 'react'

/**
 * @interface Data
 * @description The data context interface
 */
export interface Data {
    assignmentId: string
    standalone: boolean
    setIsExpired: Dispatch<SetStateAction<boolean>>
}

export const DataContext = createContext<Data>(undefined)
